import axios, { AxiosResponse } from "axios";

// const BASE_URL = "https://sodastreamapi.azurewebsites.net/products";

const BASE_URL = "https://sodastreamapi.azurewebsites.net/products";

const STOCK_URL = "https://imwengine-wa-prod-san.azurewebsites.net/SodaStream/GetAvailableStock";
const TOKEN="VMAjGM-ebaLRNA9s9DXeminxlNylrthx3ShG73WzW10C-2qpTKsA29uKCsYbK_yxET-JFynU4lyNS7dl_YWSbu-qPKKGOPCiHtd-InNmFOT4pkjqkHjpvkvpbQtIUUEasKuxop_pao-CRwnpp1KHQFOC-Q2rRVlkCxASqXFRkRKAiAJz3SwLgN1yWOV4QlL5LFgagzN93myNLgEcFZ0d0G0QBvVu39OJLVK32bR_R25aTxLJYRhyCbkDpwMYtRwhYcRWgnNC5QphFvtFzOkDBgLdDs89W2NpYIXrFv7OMEuXI8-pp5gil5otI_l2f7DBB-WvS42XIPiHFWtaCEKCOEkZVDxKFmzZtaV8045sTormQK73bugUjTIVXcb3qb3zLBYmkNna1cL5z3cngV_2jlIrZi2fhws7gw64hLi5NoVOTaowH8Yt3C-wBwuu0YmtQwN8E7JnqlJKP4QfsD-z6GgL3iGxjj0lu2gahCsPR5y8wv7mf6eE5zkHYDktXDyOQlSKwmSteS0AXeFQo-BTLBdSgSK80tqSqXtF8Cv3rRLwxLFOBnXnMplCSZ9MEcIb9LU2FVye95GMY6fCo8TyjVtDNCSbiG2nl2KbvLniLC-Q9AGysZsviA3v_QkaDU8h"

export interface Product {
  id?: number;
  banner: string;
  name: string;
  description: string;
  meta_description: string;
  meta_title: string;
  caption: string;
  ingredient: string;
  price: number;
  rating: number;
  image: string;
  category: string;
  productlinkname:string;
  productaltbanner:string;
  product_type: string;
  watermachineid?:number,
  height?: string;  
  width?: string;   
  length?: string;  
  weight?: string; 
  sku?:string;
  shorten_name?:string;
}

export interface WmsOrderData {
  OrderNumber: string;
  orderDate: string;
  customerName: string;
  companyName: string;
  contactNumber: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  city: string;
  postalCode: string;
  itemCode: string;
  warehouse: string;
  description: string;
  principle: string;
  quantity: number;
  status: string;
}

export interface StockResponse {
  warehouse: string;
  itemCode: number;
  principle: string;
  quantity: number;
}


class ProductService {
 
  async getStockByItemCode(
    itemCode: number
  ): Promise<{ data: StockResponse | null; error: string | null }> {
    try {
      const url = `${STOCK_URL}?token=${TOKEN}&itemCode=${itemCode}`;
  
      const response: AxiosResponse<StockResponse> = await axios.get(url);
  
      if (response.status >= 200 && response.status < 300) {

        return { data: response.data, error: null };
      } else {
        const error = `Error fetching data - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error during the request:", error.message);
      if (error.response) {
        console.error("Response details:", error.response.data);
      }
      return { data: null, error: error.message };
    }
  }
  
  async processWmsOrder(orderData: WmsOrderData): Promise<{ data: any | null; error: string | null }> {


    try {
      
      const url = `https://imwengine-wa-prod-san.azurewebsites.net/SodaStream/ProcessWmsOrder?token=${TOKEN}`;
      
      const response: AxiosResponse<any> = await axios.post(url, orderData, {
        headers: {
          'Content-Type': 'application/json'
        },
       
      });
  
      if (response.status >= 200 && response.status < 300) {

        return { data: response.data, error: null };
      } else {
        const error = `Error processing WMS order - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error during the request:", error.message);
      if (error.response) {
        console.error("Response details:", error.response.data);
      } else if (error.request) {
        console.error("No response received, request timeout or network error");
      }
      return { data: null, error: error.message || "Request failed" };
    }
  }

  
  async getAllProducts(): Promise<{
    data: Product[] | null;
    error: string | null;
  }> {
    try {
      const response: AxiosResponse<Product[]> = await axios.get(BASE_URL);
      if (response.status >= 200 && response.status < 300) {
        const products: Product[] = response.data;
      
        return { data: products, error: null };
      } else {
        const error = "Error fetching products";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching products:", error);
      return { data: null, error };
    }
  }

async getProductByName(
  productName: string
): Promise<{ data: Product | null; error: string | null }> {
  try {
    const response: AxiosResponse<Product> = await axios.get(
      `${BASE_URL}/name/${productName}`
    );
    if (response.status >= 200 && response.status < 300) {
      const product: Product = response.data;

      return { data: product, error: null };
    } else {
      const error = "Error fetching product by name";
      console.error(error);
      return { data: null, error };
    }
  } catch (error: any) {
    console.error("Error fetching product by name:", error);
    return { data: null, error };
  }
}

async getProductByLinkName(
  productlinkname: string
): Promise<{ data: Product | null; error: string | null }> {
  try {
    const response: AxiosResponse<Product> = await axios.get(
      `${BASE_URL}/${productlinkname}`
    );
    if (response.status >= 200 && response.status < 300) {
      const product: Product = response.data;

      return { data: product, error: null };
    } else {
      const error = "Error fetching product by productLinkName";
      console.error(error);
      return { data: null, error };
    }
  } catch (error: any) {
    console.error("Error fetching product by productLinkName:", error);
    return { data: null, error };
  }
}

  async getProductById(
    productId?: number
  ): Promise<{ data: Product | null; error: string | null; quantity?:number }> {
    try {
      const response: AxiosResponse<Product> = await axios.get(
        `${BASE_URL}/id/${productId}`
      );
      if (response.status >= 200 && response.status < 300) {
        const product: Product = response.data;

        return { data: product, error: null };
      } else {
        const error = "Error fetching product by ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching product by ID:", error);
      return { data: null, error };
    }
  }

  async createProduct(
    productData: any
  ): Promise<{ data: Product | null; error: string | null }> {
    try {
      const response: AxiosResponse<Product> = await axios.post(
        BASE_URL,
        productData
      );
      if (response.status >= 200 && response.status < 300) {
        const createdProduct: Product = response.data;

        return { data: createdProduct, error: null };
      } else {
        const error = `Error creating product - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating product:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async editProduct(
    productId: number,
    updatedProductData: any
  ): Promise<{ data: any| null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.put(
        `${BASE_URL}/id/${productId}`,
        updatedProductData
      );
      if (response.status >= 200 && response.status < 300) {
        const updatedProduct: Product = response.data;

        return { data: updatedProduct, error: null };
      } else {
        const error = `Error updating product - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating product:", error.message);
     
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async deleteProduct(
    productId: number
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.delete(
        `${BASE_URL}/id/${productId}`
      );

      if (response.status >= 200 && response.status < 300) {

        return { data: response.data, error: null };
      } else {
        const error = `Error deleting product - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error deleting product:", error.message);
     
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
}

const productServiceInstance = new ProductService();
export default productServiceInstance;